import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICombinationType, IPaginationParams } from '@interfaces';
import { ApiResponse } from '@shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CombinationTypesService {
  constructor(private readonly http: HttpClient) {}

  getAllCombinationTypes(params: IPaginationParams): Observable<ApiResponse> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.append(key, String((params as any)[key]));
      });
    }
    params?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      httpParams = httpParams.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>('/v1/admin/combination-types', { params: httpParams });
  }

  getCombinationTypeById(id: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`/v1/admin/combination-types/${id}`);
  }

  editCombinationType(id: string, combinationTypeData: ICombinationType): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/combination-types/${id}`, combinationTypeData);
  }

  deleteCombinationType(id: string): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`/v1/admin/combination-types/${id}`);
  }

  createCombinationType(combinationTypeData: ICombinationType): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`/v1/admin/combination-types`, combinationTypeData);
  }

  changeSequence(data: any): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/combination-types/update-sequence`, { data });
  }

  exportList(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');
    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(`/v1/admin/combination-types/export`, filterData, options);
  }
}
